import {
   HealthcareProviderWaitlistTimeSlotReservedPatientNotificationConfigurationQuery,
   HealthcareProviderWaitlistTimeSlotReservedTokenInConfirmationEnabledQuery,
   HealthcareProviderWaitlistTimeSlotReservedTokenInConfirmationEnabledSetCommand,
} from '@dreryk/egabinet-phone-notification-frontend-api';

import { refetchCqrsQuery, useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { patientPhoneNotificationTranslationKeys } from '../../translations';

import { PatientPhoneNotificationWaitlistProposedAppointmentResponseTokenToggleFormBean } from './PatientPhoneNotificationWaitlistProposedAppointmentResponseTokenToggle.types';

export const useCurrentHealthcareProviderWaitlistTimeSlotReservedTokenInConfirmationEnabledSetCommand = (): UseCqrsCommandResult<
   void,
   PatientPhoneNotificationWaitlistProposedAppointmentResponseTokenToggleFormBean
> => {
   return useCqrsCommand(
      (parameters) => {
         const command = new HealthcareProviderWaitlistTimeSlotReservedTokenInConfirmationEnabledSetCommand();
         command.enabled = Choice.of(parameters.responseTokenEnabled ?? false);
         return command;
      },
      {
         onSuccess: (__, parameters) => {
            dispatchSnackbarPositiveEvent(
               parameters.responseTokenEnabled
                  ? patientPhoneNotificationTranslationKeys.notificationToggle
                       .waitlistProposedAppointmentResponseTokenToggleSaveOn
                  : patientPhoneNotificationTranslationKeys.notificationToggle
                       .waitlistProposedAppointmentResponseTokenToggleSaveOff
            );
            refetchCqrsQuery(HealthcareProviderWaitlistTimeSlotReservedTokenInConfirmationEnabledQuery);
            refetchCqrsQuery(HealthcareProviderWaitlistTimeSlotReservedPatientNotificationConfigurationQuery);
         },
      }
   );
};
